var exports = {
  "k": "container__xyb5hD",
  "v": "inner__AYW6za",
};

module.exports = exports;
